import React from "react";
import "./LeftImageRightContent.css";

const LeftImageRightContent = () => {
  return (
    <section className="lir-section">
      <div className="lir-container">
        <div className="lir-image-box">
          <img
            src="https://static.wixstatic.com/media/6870b3_3b9701eb28b943f8aebe7f5a23bd9c26~mv2.jpg/v1/crop/x_11,y_116,w_519,h_559/fill/w_623,h_671,al_c,lg_1,q_85,enc_avif,quality_auto/NTT%20Course%20Training%20.jpg"
            alt="Primary teacher training classroom"
            title="Primary teacher training classroom"
            className="lir-image"
          />
        </div>

        <div className="lir-content-box">
          <h2 className="lir-title">Primary Teachers Training
(in-service training)</h2>

          <ul className="lir-points">
            <li>✔ Primary Teachers Training Certification</li>
            <li>✔ 1 year Course</li>
            <li>✔ Theory & Practicals Sessions</li>
            <li>✔ Online or Regular Mode</li>
            <li>✔ VAP's with Certification (Value-Added Programs)</li>
            <li>✔ Expert Faculty</li>
            <li>✔ Placement Assistance</li>
            <li>✔ & much more...</li>
          </ul>
        </div>
      </div>
    </section>
  );
};

export default LeftImageRightContent;
